type Props = {
  clicks: number
  opens: number
  softBounced: boolean
  hardBounced: boolean
  bounced: string
}

export const getColorByInvitationStatus = ({
  clicks, opens, softBounced, hardBounced, bounced,
}: Props) => {
  if (clicks) {
    return "emailStatus.clicked"
  }
  if (opens) {
    return "emailStatus.opened"
  }
  if (softBounced) {
    return "emailStatus.softBounced"
  }
  if (hardBounced) {
    return "emailStatus.hardBounced"
  }
  if (bounced) {
    return "emailStatus.bounced"
  }

  return "emailStatus.unopened"
}

export default null
